
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/documents",
      function () {
        return require("private-next-pages/user/documents/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/documents"])
      });
    }
  